module.exports = __webpack_public_path__ + "static/media/reiniciar.3bbe3684.svg";